import { ACCOUNT_FEATURE } from '@socialive/common';
import { useFeature } from '@socialive/features';
import PropTypes from 'prop-types';
import DownloadButtonLegacy from './DownloadButtonLegacy';
import DownloadButtonWithConversions from './DownloadButtonWithConversions';

const DownloadButtonPicker = ({ type, namingConvention, downloadFile, newTitle, buttonId, pagePath }) => {
  const [, { enabled }] = useFeature(ACCOUNT_FEATURE.EXPORT_VIDEO);

  if (enabled) {
    return (
      <DownloadButtonWithConversions
        namingConvention={namingConvention}
        downloadFile={downloadFile}
        newTitle={newTitle}
        pagePath={pagePath}
      />
    );
  }

  return (
    <DownloadButtonLegacy
      type={type}
      namingConvention={namingConvention}
      downloadFile={downloadFile}
      newTitle={newTitle}
      buttonId={buttonId}
    />
  );
};

DownloadButtonPicker.defaultProps = {
  namingConvention: '',
  buttonId: null,
  pagePath: null,
};

DownloadButtonPicker.propTypes = {
  downloadFile: PropTypes.shape({
    createdAt: PropTypes.number,
    durationMillis: PropTypes.number,
    durationSeconds: PropTypes.number,
    file: PropTypes.string,
    m3u8Url: PropTypes.string,
    outfile: PropTypes.string,
    title: PropTypes.string.isRequired,
    startedAt: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  buttonId: PropTypes.string,
  namingConvention: PropTypes.string,
  newTitle: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  pagePath: PropTypes.string,
};

export default DownloadButtonPicker;
